import React from 'react';
import { Link } from 'react-router-dom';

import { Logo } from './Logo';
import classes from './Header.scss';

export const HeaderLogo = React.memo(function HeaderLogo() {
    return (
        <Link
            aria-label="Click the Woodies logo and go back to the home page"
            to="/"
            className={classes.headerLogoLink}
            data-test-id="logo"
        >
            <Logo variant="normal" />
        </Link>
    );
});
